<template lang="pug">
el-header(style="height:64px;")
  el-row(type="flex" justify="space-between")
    el-col(:span="16")
      Breadcrumb
    el-col(:span="4" class="right-header")
      el-dropdown(trigger="click" v-intro="$t('Guide.header_guide01')" v-intro-disable-interaction="false")
        span.el-dropdown-link
          img(:src="checkThumb()")
          | {{user.name}}
          i.el-icon-arrow-down.el-icon--right
        el-dropdown-menu(slot="dropdown")
          template(v-for="(menu, i) in submenusForUser(user)")
            template(v-if="menu.line")
              el-dropdown-item(divided :index="String(i)")
                router-link(:to="{path: menu.path}") {{ $t(menu.name) }}
            template(v-else)
              el-dropdown-item(:index="String(i)")
                router-link(:to="{path: menu.path}") {{ $t(menu.name) }}
          el-dropdown-item(divided)
            router-link(:to="{path: '/sign_in'}" @click.native="signOut") {{ $t('submenus.logout') }}
</template>

<script>
import submenusForUser from '@/utils/defines/user_submenus.js'
import Breadcrumb from './Breadcrumb'
export default {
  components: { Breadcrumb },
  mixins: [submenusForUser],
  data () {
    return {
    }
  },
  computed: {
    user: function() {
      return this.$store.state.user.user
    },
    breadcrumbs: function() {
      return this.$store.state.global.breadcrumbs
    },
    // ユーザーが契約しているサービス
    services: function() {
      return this.user.services;
    },
  },
  methods: {
    hasService: function(service_name) {
      for(const service of this.services) {
        if(service.name === service_name) {
          return true
        }
      }
      return false
    },
    checkThumb: function(){
      return this.user.thumb_url != null ? this.user.thumb_url : require("@/assets/default.svg")
    },
    signOut: function(){
      this.$store.dispatch('signOutReset')
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

header.el-header ::v-deep {
  height: 64px;
  padding: 0 40px;
  border-bottom:1px solid rgba(0,0,0,0.1);

  h1 {
    display: inline-block;
    font-size: 20px;
    font-weight: normal;
    margin: 0;
    line-height: 64px;
    vertical-align: middle;
  }
  span.pan,
  span.separate,
  a {
    display: inline-block;
    margin-right: 10px;
    color: #BBB;
    transition: all .3s ease-in-out;
  }
  a:hover {
    color: $safe;
  }
}
.el-dropdown {
  top: 20px;
}
.right-header {
  text-align: right;
}
.el-dropdown-link {
  cursor: pointer;
  color: #333;
  font-size: 13px;
  font-weight: 600;
  i { color: #999; }
  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
    margin-right: 10px;
    border-radius: 12px;
    vertical-align: middle;
  }
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-dropdown-menu {
  min-width: 200px;
  h2 {
    font-size: 12px;
    color: #999;
    padding: 10px 10px 10px 20px;
    margin-top: 6px;
    border-top: 1px solid $border;
  }
  .el-dropdown-menu__item {
    padding: 0;

    a {
      display: block;
      padding: 0 20px;
      color: #333;

      img.menu_icon {
        width: 20px;
        vertical-align: middle;
        margin-right: 5px;

        &.members {
          width: 18px;
          margin-right: 7px;
        }
      }
    }
    &:not(.is-disabled):hover {
      background: rgba(0,0,0,0.05);
    }
  }
  .el-dropdown-menu__item--divided:before {
    margin: 0;
  }
}
</style>
